import { createFileRoute, Outlet, useLocation, useNavigate } from "@tanstack/react-router";
import { Segmented, Flex, theme } from "antd";

export const Route = createFileRoute("/_protected/$organizationId/$flowId/sessions")({
  component: SessionsLayout,
});

function SessionsLayout() {
  const { token } = theme.useToken();
  const { organizationId, flowId } = Route.useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = location.pathname.includes("/readiness") ? "readiness" : "sessions";

  return (
    <div>
      <Flex style={{ position: "sticky", top: 0, zIndex: 11, background: token.colorBgLayout, paddingBottom: token.marginMD }}>
        <Segmented
          value={activeTab}
          options={[
            { value: "sessions", label: "Sessions" },
            { value: "readiness", label: "Readiness" },
          ]}
          onChange={(value) => {
            const to = value === "readiness"
              ? "/$organizationId/$flowId/sessions/readiness"
              : "/$organizationId/$flowId/sessions";
            navigate({ to, params: { organizationId, flowId } });
          }}
        />
      </Flex>
      <Outlet />
    </div>
  );
}
